import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/solid';
import { AlertTypeToIconMap } from './types';
import { AlertCircleIcon, DownloadIcon } from '../Icons';

export const iconMap: AlertTypeToIconMap = {
  WARNING: (
    <div className='rounded-full border-2 border-yellow-400/20 p-0.5'>
      <div className='rounded-full border-2 border-yellow-400/60 p-0.5'>
        <AlertCircleIcon className='relative z-10 size-5 text-yellow-400' aria-hidden='true' />
      </div>
    </div>
  ),
  INFO: (
    <div className='rounded-full border-2 border-yellow-400/20 p-0.5'>
      <div className='rounded-full border-2 border-yellow-400/60 p-0.5'>
        <AlertCircleIcon className='relative z-10 size-5 text-yellow-400' aria-hidden='true' />
      </div>
    </div>
  ),
  ERROR: <XCircleIcon className='size-5 text-red-400' aria-hidden='true' />,
  SUCCESS: <CheckCircleIcon className='size-5 text-green-400' aria-hidden='true' />,
};

export const actionIconMap: Partial<AlertTypeToIconMap> = {
  INFO: <DownloadIcon className='size-5 text-brand-700' aria-hidden='true' />,
};
